var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _g2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalacaColgante(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 520",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "dress",
    x1: 82,
    y1: 280,
    x2: 238,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#073b45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102c38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hair",
    x1: 80,
    y1: 90,
    x2: 210,
    y2: 330,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#172c38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#071c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#351d2b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "face",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 95 -65 0 150 160)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d8c5a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brim",
    x1: 30,
    y1: 88,
    x2: 269,
    y2: 131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#101f32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#29213a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#102d36"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 0v63",
    stroke: "#f0d6a5",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144 62h12l10 12h-32z",
    fill: "#c89959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69 184c-16 29-22 69-15 124l-14 113c-4 31 9 62 32 83l34-22 20 26h51l20-26 33 22c24-21 37-52 32-83l-14-112c8-52 1-96-19-127z",
    fill: "url(#hair)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 235c-29 21-41 56-38 104l-14 85c-5 31 6 58 26 77l18-15 14 27h26l-8-84 12-91zM210 235c29 21 41 56 38 104l14 85c5 31-6 58-26 77l-18-15-14 27h-26l8-84-12-91z",
    fill: "url(#hair)",
    stroke: "#060f1c",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103 129c0-48 19-72 47-72s47 24 47 72v50c0 42-19 68-47 68s-47-26-47-68z",
    fill: "url(#face)",
    stroke: "#42313a",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104 145c4-21 17-35 35-35 10 0 18 4 25 12 7-8 15-12 25-12 4 0 8 1 12 3-7-34-24-51-51-51-28 0-46 22-46 65z",
    fill: "url(#hair)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112 151c3-14 13-22 25-22 11 0 19 8 21 22-4 16-12 25-23 25-12 0-20-9-23-25Zm38 0c3-14 13-22 25-22 11 0 19 8 21 22-4 16-12 25-23 25-12 0-20-9-23-25Z",
    fill: "#19212b",
    stroke: "#a4464b",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 151,
    rx: 5,
    ry: 8,
    fill: "#edbd82"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 151,
    rx: 5,
    ry: 8,
    fill: "#edbd82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M156 163l-9 22 9 5 8-5z",
    fill: "#633845"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136 202c6-5 12-7 20-7s14 2 20 7m-40 0c7 3 13 4 20 4s13-1 20-4",
    stroke: "#8d3845",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140 202v19m8-19v22m8-22v23m8-23v22m8-22v19",
    stroke: "#5a3540",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M112 145c5-18 16-28 27-28m-27 47c4 6 8 10 14 12m59-31c-5-18-16-28-27-28m27 47c-4 6-8 10-14 12",
    stroke: "#e3a84f",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147 188c-3-8-10-11-16-7 1 8 6 13 16 13m18-6c3-8 10-11 16-7-1 8-6 13-16 13",
    fill: "#a84350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30 103c7-43 48-72 120-72s113 29 120 72c-53 23-187 23-240 0Z",
    fill: "url(#brim)",
    stroke: "#d0a15c",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91c17-34 40-48 63-48s46 14 63 48",
    stroke: "#d9b36f",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104c59 17 131 17 190 0",
    stroke: "#c28e53",
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78c-13-11-12-29 2-36 13-7 25 1 26 15 10-20 34-19 39-1 11-17 35-11 34 8 13-12 33-4 31 12-1 11-14 19-27 19H78c-5-5-9-11-12-17Z",
    fill: "#963c4b",
    stroke: "#e3b36b",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f0c779",
    stroke: "#5b3541",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 57,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 48,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 45,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 55,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 66,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 48,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131,
    cy: 39,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 36,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153,
    cy: 46,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 57,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 58,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 49,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 46,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218,
    cy: 56,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 67,
    r: 7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#173c40"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 79,
    cy: 56,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139,
    cy: 47,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 57,
    r: 3
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M116 239c-24 14-38 40-42 75l-18 176c-2 16 9 27 25 27h139c16 0 27-11 25-27l-18-176c-4-35-18-61-42-75-19 14-50 14-69 0Z",
    fill: "url(#dress)",
    stroke: "#0a252e",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116 242c18 22 50 22 68 0l17 24c-27 25-75 25-102 0z",
    fill: "#f0d9bc",
    stroke: "#aa6e58",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111 272c27 19 51 19 78 0m-83 20c30 23 59 23 89 0m-95 24c34 25 67 25 101 0m-107 26c37 27 75 27 113 0",
    stroke: "#d6a45c",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113 277c-10 24-13 52-14 80m88-80c10 24 13 52 14 80",
    stroke: "#e7c07b",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M101 359c32 21 66 21 98 0l28 132H73z",
    fill: "#8b3447",
    fillOpacity: 0.72
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88 382c40 26 84 26 124 0m-130 32c44 28 92 28 136 0m-143 32c47 30 102 30 149 0m-157 31c53 29 112 29 165 0",
    stroke: "#e7bd71",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127 279c-12 13-20 30-21 49m67-49c12 13 20 30 21 49",
    stroke: "#f2ddbf",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143 251c2 10 4 17 7 21 3-4 5-11 7-21",
    stroke: "#a83d50",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120 324c11-12 22-12 30 0-8 12-19 13-30 0Zm30 0c11-12 22-12 30 0-8 12-19 13-30 0Z",
    fill: "#d85c5c",
    stroke: "#f3d59e",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 324,
    r: 5,
    fill: "#f4d58d"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M88 491h124",
    stroke: "#e5bd77",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalacaColgante);
export default __webpack_public_path__ + "static/media/calaca-colgante.e17e21cb56afb775c042d325f986bef1.svg";
export { ForwardRef as ReactComponent };